// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3J0qP","tab":"Tabs_tab__KMZb4","tabActive":"Tabs_tabActive__Qhkik"};